import { Group, Layout } from "@/comn/components";
import { useModal } from "@/comn/hooks";
import { comnEnvs } from "@/comn/utils";
import classNames from "classnames";

export const TaneswPortalMainInformation = () => {
    const modal = useModal();

    const list = [
        {
            img: `${process.env.PUBLIC_URL}/imgs/portal-HSCode.svg`,
            name: "Auction",
            url: "/cgme/onln/actn/cgme0504001q?menuId=menu_cgme0833",
            link: true,
        },
        {
            img: `${process.env.PUBLIC_URL}/imgs/portal-CountryCode.svg`,
            name: "Country Code",
            url: comnEnvs.popup.cntyCd,
        },
        {
            img: `${process.env.PUBLIC_URL}/imgs/portal-RegionCode.svg`,
            name: "Region/IATA",
            url: comnEnvs.popup.cityCd,
        },
        {
            img: `${process.env.PUBLIC_URL}/imgs/portal-CommonCode.svg`,

            name: "Common Code",
            url: comnEnvs.popup.comnCd,
        },
        {
            img: `${process.env.PUBLIC_URL}/imgs/portal-CurencyCode.svg`,

            name: "Curency Code",
            url: comnEnvs.popup.currCd,
        },
        {
            img: `${process.env.PUBLIC_URL}/imgs/portal-PublicHoliday.svg`,

            name: "Public Holiday",
            url: comnEnvs.popup.hldy,
        },
        {
            img: `${process.env.PUBLIC_URL}/imgs/portal-SearchWarehouse.svg`,
            name: "Search warehouse",
            url: comnEnvs.popup.wrhsCd,
        },
        {
            img: `${process.env.PUBLIC_URL}/imgs/portal-HSCode_modified.svg`,
            name: "HS Code",
            url: comnEnvs.popup.hsCd,
        },
    ];

    return (
        <Group height="100%">
            <Group.Header>
                <h2>Information</h2>
            </Group.Header>
            <Group.Body padding={0}>
                <Group.Section>
                    <div className="flex gap-10 mx-auto max-w-full overflow-auto p-10">
                        {list.map((item) => {
                            const { img, name, url, link } = item;
                            return (
                                <div
                                    key={`Main Information:${name}`}
                                    className="cursor-pointer flex flex-col items-center gap-4 w-24"
                                    onClick={() => {
                                        if (link) {
                                            window.location.href = `${url}`;
                                        } else {
                                            modal.openModal({
                                                url,
                                                size: "sm",
                                                params: { ptlYn: "Y" },
                                            });
                                        }
                                    }}
                                >
                                    <div
                                        className={classNames(
                                            "p-4 flex items-center justify-center rounded-full size-20",
                                            name === "Auction" ? "bg-tanesw" : "bg-header",
                                        )}
                                    >
                                        <img
                                            src={img}
                                            alt={name}
                                            title={name}
                                            className={classNames(
                                                name === "Auction" ? "brightness-[3]" : "dark:brightness-150",
                                            )}
                                        />
                                    </div>
                                    {name && <div className="text-center">{name}</div>}
                                </div>
                            );
                        })}
                    </div>
                </Group.Section>
            </Group.Body>
        </Group>
    );
};
